module.exports = __webpack_public_path__ + "img/galery26.a74ff257.jpg";